import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4l16 0","key":"svg-0"}],["path",{"d":"M9 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z","key":"svg-1"}]]

const IconLayoutAlignTop = createReactComponent('outline', 'layout-align-top', 'LayoutAlignTop', __iconNode);

export default IconLayoutAlignTop;